import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Model } from '../../../hooks/useModelState';
import {
  getBulkEditSceneState,
  subscribeToBulkEditSceneState
} from '../bulkEditSceneState';
import { IsolateTargets } from '../bulkEditIsolate';

export const TOOLTIP_DELAY_MS = 400;

export const TOOLBAR_MENU_Z_INDEX = 12100;
export const TOOLBAR_TOOLTIP_Z_INDEX = 12200;

export const buildTooltipContent = (title: string, description?: string) => (
  <Box sx={{ px: 0.5, py: 0.25, maxWidth: 240 }}>
    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', fontSize: 12 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="caption" sx={{ display: 'block', fontSize: 11, opacity: 0.85, mt: 0.25 }}>
        {description}
      </Typography>
    )}
  </Box>
);

export const splitSelectedIdsByType = (model: Model, selectedIds: string[]): IsolateTargets => {
  const nodeIds: string[] = [];
  const spoolIds: string[] = [];
  const stopeIds: string[] = [];
  const allStopes = Object.values(model.stopes).flat();
  const stopeIdSet = new Set(allStopes.map((s) => s?.data?.stopeId).filter(Boolean) as string[]);
  selectedIds.forEach((id) => {
    if (model.nodes[id]) nodeIds.push(id);
    else if (model.spools[id]) spoolIds.push(id);
    else if (stopeIdSet.has(id)) stopeIds.push(id);
  });
  return { nodeIds, spoolIds, stopeIds };
};

export const filterIdsInModel = (model: Model, ids: string[]): string[] => {
  const { nodeIds, spoolIds, stopeIds } = splitSelectedIdsByType(model, ids);
  const present = new Set([...nodeIds, ...spoolIds, ...stopeIds]);
  return ids.filter((id) => present.has(id));
};

export const useBulkEditSceneState = () => {
  const [, forceUpdate] = React.useReducer((x: number) => x + 1, 0);
  React.useEffect(() => {
    const unsubscribe = subscribeToBulkEditSceneState(() => forceUpdate());
    return unsubscribe;
  }, []);
  return getBulkEditSceneState();
};
